import { useRecoilValue } from "recoil";
import {
  chargeCancelMileageMember,
  getMileageMemberHistory,
  PubMemberDto,
  MileageMemberHistoryResponse,
} from "../../../../../../api/member";
import { pubState } from "../../../../../../recoil/pub.atom";
import {
  MileageHeader,
  MileageHistoryItemWrapper,
  MileageHistoryTable,
  MileageHistoryWrapper,
  MileagePageWrapper,
} from "../../style";
import { useEffect, useState } from "react";
import { DialogWrapper } from "../../../../../../component/Dialog/style";
import { Overlay } from "../../../../../../styles/popup";
import { MileageMenuRefund } from "../../../../../../api/pub-product";
import { formatDate } from "../../../../../../utils/date";
import { Title } from "../../../../../../styles/page";
import { formatMileageLogType } from "../../../../utils/settlement.util";

interface MileageHistoryProps {
  onClose: () => void;
  member: PubMemberDto | null;
  getMember: () => void;
}
const MileageHistory = ({
  onClose,
  member,
  getMember,
}: MileageHistoryProps) => {
  const pub = useRecoilValue(pubState);
  const size = 10;
  const [allList, setAllList] = useState<MileageMemberHistoryResponse[]>([]);
  const [list, setList] = useState<MileageMemberHistoryResponse[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [isBuyCancel, setIsBuyCancel] = useState<string>("");
  const [cancelItemId, setCancelItemId] = useState<number>(0);

  const getData = async () => {
    if (!pub || !member) return;
    try {
      const res = await getMileageMemberHistory(member.memberId);
      setAllList(res);
      setTotalPage(Math.max(1, Math.ceil(res.length / size)));
      setList(res.slice((currentPage - 1) * size, currentPage * size));
    } catch {
      setList([]);
    }
  };

  const handleChargeCancel = async () => {
    try {
      await chargeCancelMileageMember(cancelItemId);
      alert("처리 되었습니다. ");
      setCancelItemId(0);
      setIsBuyCancel("");
      getData();
      getMember();
    } catch {
      alert("재시도해주세요. ");
    }
  };

  const handleBuyCancel = async () => {
    try {
      await MileageMenuRefund(cancelItemId);
      alert("환불 처리 되었습니다. ");
      setCancelItemId(0);
      setIsBuyCancel("");
      getData();
      getMember();
    } catch {
      alert("재시도해주세요. ");
    }
  };

  useEffect(() => {
    getData();
  }, [member]);

  useEffect(() => {
    setList(allList.slice((currentPage - 1) * size, currentPage * size));
  }, [currentPage]);

  const onPageChange = async (nextPage: number) => {
    if (currentPage + nextPage <= 0) return;
    if (currentPage + nextPage > totalPage) return;
    setCurrentPage(currentPage + nextPage);
  };

  const formatUnit = (type: string) => {
    if (type === "BUY_CANCEL") {
      return "+";
    } else if (type.includes("CANCEL")) {
      return "-";
    } else if (type === "MANUAL_CHARGE") {
      return "+";
    } else if (type === "BUY" || type === "EXPIRES") {
      return "-";
    } else {
      return "+";
    }
  };

  const buyCancel = (id: number) => {
    return allList.some((item) => {
      if (item.type === "BUY_CANCEL") {
        return item.memberPurchaseId === id;
      } else {
        return false;
      }
    });
  };

  return (
    <>
      {isBuyCancel !== "" && (
        <>
          <DialogWrapper isCancel={true} isWide={true}>
            <div className="title">
              {isBuyCancel === "buy" ? "환불 처리를" : "수동 지급 취소를"}
              <br />
              진행하시겠습니까?
            </div>
            <div className="button-wrapper">
              <div
                className="red-button"
                onClick={() => {
                  if (isBuyCancel === "buy") {
                    handleBuyCancel();
                  } else {
                    handleChargeCancel();
                  }
                }}
              >
                예
              </div>
              <div
                className="white-button"
                onClick={() => {
                  setIsBuyCancel("");
                }}
              >
                아니오
              </div>
            </div>
          </DialogWrapper>
          <Overlay $zIndex={1005} />
        </>
      )}
      <MileageHistoryWrapper>
        <MileageHeader>
          <Title size={20}>내역</Title>
          <div className="right">
            <div className="name">
              보유 마일리지 <span>{member?.point.toLocaleString()}</span>
            </div>
            <img
              src="/image-web/solution/close.svg"
              alt="close"
              onClick={() => onClose()}
            />
          </div>
        </MileageHeader>
        <MileageHistoryTable>
          <div className="header">
            <div className="item">날짜</div>
            <div className="item">구분</div>
            <div className="item">메뉴</div>
            <div className="item">마일리지(+,-)</div>
            <div className="back"></div>
          </div>
          <div className="body">
            {list.length === 0 ? (
              <div className="no-data">내역이 없습니다. </div>
            ) : (
              list.map((item, index) => (
                <MileageHistoryItemWrapper key={index}>
                  <div className="item">{formatDate(item.date)}</div>
                  <div className="item">{formatMileageLogType(item.type)}</div>
                  <div className="item">{item.menu ? item.menu : "-"}</div>
                  <div className="item">
                    {formatUnit(item.type)}
                    {item.point.toLocaleString()}
                  </div>
                  <div
                    className="back"
                    onClick={() => {
                      if (item.type === "BUY") {
                        setIsBuyCancel("buy");
                        setCancelItemId(item.memberPurchaseId);
                      } else if (item.type === "MANUAL_CHARGE") {
                        setIsBuyCancel("manual");
                        setCancelItemId(item.id);
                      }
                    }}
                  >
                    {item.type === "BUY" && !buyCancel(item.memberPurchaseId)
                      ? "환불"
                      : item.type === "MANUAL_CHARGE" && !item.isWithdraw
                        ? "지급 취소"
                        : ""}
                  </div>
                </MileageHistoryItemWrapper>
              ))
            )}
          </div>
        </MileageHistoryTable>
        <MileagePageWrapper>
          <img
            src="image-web/solution/page-left.png"
            alt="arrow"
            onClick={() => onPageChange(-1)}
          />
          <div className="page">
            {currentPage} / {totalPage}
          </div>
          <img
            src="image-web/solution/page-right.png"
            alt="arrow"
            onClick={() => onPageChange(1)}
          />
        </MileagePageWrapper>
      </MileageHistoryWrapper>
    </>
  );
};

export default MileageHistory;
